import * as z from "zod";

const req = (msg: string) =>
  z.preprocess((v) => v ?? "", z.string().trim().min(1, msg));

export const mspFormSchema = z
  .object({
    organization_name: req("Please enter company name."),
    website: req("Please enter domain."),

    company_phone: z.preprocess((v) => v ?? "", z.string().trim().optional()),
    company_email: z.preprocess(
      (v) => v ?? "",
      z.string().trim().min(1, "Please enter company email ID.")
    ),

    company_street_address: z.string().optional(),

    company_country_id: z.preprocess(
      (v) => Number(v ?? 0),
      z.number().min(1, "Please select country.")
    ),
    company_state_id: z.preprocess(
      (v) => Number(v ?? 0),
      z.number().min(1, "Please select state.")
    ),
    company_city_id: z.preprocess(
      (v) => Number(v ?? 0),
      z.number().min(1, "Please select city.")
    ),

    timezone: req("Please select timezone."),

    company_postal_code: z.preprocess(
      (v) => v ?? "",
      z.string().trim().optional()
    ),

    tax_id: z.string().optional(),

    // Region & Timezone
    region_id: z.preprocess(
      (v) => Number(v ?? 0),
      z.number().min(1, "Please select region.")
    ),

    // Primary Contact Information
    first_name: req("Please enter first name."),
    last_name: req("Please enter last name."),

    corporate_email: z.preprocess(
      (v) => v ?? "",
      z.string().trim().min(1, "Please enter corporate email.")
    ),

    designation: req("Please enter designation."),
    job_title: req("Please enter position."),

    mobile_phone: z.preprocess(
      (v) => v ?? "",
      z.string().trim().min(1, "Please enter mobile number.")
    ),

    work_phone_no: z.string().optional(),
    street_address: z.string().optional(),

    country_id: z.preprocess(
      (v) => Number(v ?? 0),
      z.number().min(1, "Please select country.")
    ),
    state_id: z.preprocess(
      (v) => Number(v ?? 0),
      z.number().min(1, "Please select state.")
    ),
    city_id: z.preprocess(
      (v) => Number(v ?? 0),
      z.number().min(1, "Please select city.")
    ),
    postal_code: z.preprocess((v) => v ?? "", z.string().trim().optional()),

    // Product Information - API Integration
    product: req("Please choose a product."),
    plan: req("Please choose a plan."),
    billing_frequency: req("Please choose billing frequency."),

    no_of_licenses: z.preprocess((val) => {
      if (val === null || val === undefined || val === "") return 0;
      const num = Number(val);
      return Number.isNaN(num) ? 0 : num;
    }, z.number().min(1, "Number of licenses must be at least 1.")),

    unit_price: z.string().default(""),

    plan_price_id: z.preprocess(
      (v) => Number(v ?? 0),
      z.number().min(1, "Please select a valid pricing plan.")
    ),

    // Payment Information
    total_paid_amount: z.preprocess(
      (val) => {
        if (val === null || val === undefined || val === "") return 0;
        const num = Number(val);
        return Number.isNaN(num) ? 0 : num;
      },
      z
        .number()
        .min(0, "Total amount must be a positive number.")
        .refine((val) => val > 0, "Total amount must be greater than zero.")
    ),

    discount: z.preprocess((val) => {
      if (val === null || val === undefined || val === "") return 0;
      const num = Number(val);
      return Number.isNaN(num) ? 0 : num;
    }, z.number().min(0, "Discount must be a positive number.").max(100, "Discount cannot exceed 100%.").optional()),

    payment_mode: req("Please choose payment mode."),
    transaction_ref: z.string().optional(),
    date_of_payment: req("Please select date of payment."),
    expiration_date: z.string().optional(),
    comment: z.string().optional().default(""),
    cognito_url: z.string().default(import.meta.env.VITE_DEFAULT_COGNITO_URL),
  })
  .superRefine((data, ctx) => {
    if (
      data.date_of_payment &&
      data.expiration_date &&
      data.expiration_date < data.date_of_payment
    ) {
      ctx.addIssue({
        code: "custom",
        path: ["expiration_date"],
        message: "Subscription expiration date must be after payment date.",
      });
    }
  });

export type FormValues = z.infer<typeof mspFormSchema>;
